import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';

import { Translate } from '@core/constant';

import { LinkGoBackBase } from './LinkGoBackBase';
import { LinkGoBackBaseProps } from './interface-link';

export const LinkGoBackRouter = ({ children, ...restProps }: LinkGoBackBaseProps): JSX.Element => {
  const router = useRouter();
  const { t } = useTranslation(Translate.common.LINK);

  return (
    <LinkGoBackBase onClick={() => router.back()} {...restProps}>
      {children || t('back.title')}
    </LinkGoBackBase>
  );
};
